import { Client } from "@/Common/Api/Client";
import { PatientRefIntervenorWithDetailsModel } from "@/Common/Models/Patient/PatientRefIntervenorWithDetailsModel";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { AbstractDirectoryPreFaxCallback } from "./AbstractDirectoryPreFaxCallback";
import { DirectoryHealthCareProvider } from "./DirectoryHealthCareProvider";
import { DirectoryEntityPatientLink } from "./DirectoryPatientLinkUpdate";

export class DirectoryExternalProviderPreferredFaxNumberUpdate extends AbstractDirectoryPreFaxCallback<DirectoryEntityPatientLink> {
    public async trigger(): Promise<void> {
        const model = this.model;
        if (!model?.directoryEntity || !model?.selectedFaxNumberId || !model?.patientContactId || model?.entityType !== DirectoryEntityType.HealthcareProvider)
            return;

        const healthCareProvider = model.directoryEntity as DirectoryHealthCareProvider;

        const intervenors = patientStore.PatientProfileCliniciansModels?.[model.patientContactId]
            ?.get("IntervenorsOnFile")
            ?.toArray()
            ?? [];

        if (!intervenors.any())
            return;

        const intervenorsDto = intervenors.map((item: PatientRefIntervenorWithDetailsModel) => {
            const intervenor = item.GetNewIntervenorDTO();

            if (item.Model.HealthCareProvider?.id === healthCareProvider.id)
                intervenor.DirectoryFaxNumberId = model.selectedFaxNumberId;

            return item;
        });

        let request = {
            PatientContactFacetId: patientStore.PatientUIModels[model.patientContactId]?.get("PatientContactFacetId"),
            PatientRefIntervenors: intervenorsDto.map(p => p.Model.Intervenor)
        };

        const response = await Client.postAsync(ServerOperations.Server.Myle_Patient_Clinicians_Update, request);

        if (!response.isSuccess)
            sessionStore.showPopup(response.errors);
    }
}
